import { Col, Row, Form, Input, InputNumber } from 'antd';
import { useContext } from 'react';
import { PageContext } from '../../../lib/context';

const MeterForm = () => {
  const { form, _onFinish } = useContext(PageContext);
  return (
    <Form layout="vertical" form={form} onFinish={_onFinish}>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Meter Id"
            name="serial_number"
            rules={[{ required: true, message: 'Serial number is required' }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Size" name="size">
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="Model" name="model">
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Brand" name="brand">
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="Latitude" name="latitude">
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Longitude" name="longitude">
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name="id" hidden={true}>
        <InputNumber />
      </Form.Item>
    </Form>
  );
};

export default MeterForm;
